module.exports = __webpack_public_path__ + "static/media/61.12063c7d.jpg";